<template>
    <IndexModelLayout
        :createRoute="$route('admin::my-vacations.create')"
        :modelNamePlural="__('admin::vacations.vacations')"
    >

        <Table
            :headings="[
                __('admin::labels.period'),
                __('admin::labels.state'),
                __('admin::labels.deputy_user'),
                __('admin::labels.texts'),
                __('admin::labels.vacation_notice'),
                __('admin::labels.comment'),
            ]"
            :paginator="paginator"
            :withFilters="false"
        >

            <template #results>
                <tr v-for="vacation in paginator.data" :key="vacation.id">
                    <td>{{ $date(vacation.starts_at) }} - {{ $date(vacation.ends_at) }}</td>
                    <td>
                        <span
                            class="inline-block py-1 px-2 text-sm rounded-md"
                            :class="{
                                'bg-purple-200 text-purple-700': vacation.state === 'request',
                                'bg-blue-200 text-blue-700': vacation.state === 'upcoming',
                                'bg-yellow-200 text-yellow-700': vacation.state === 'current',
                                'bg-gray-200 text-gray-700': vacation.state === 'old',
                            }"
                        >
                            <span v-if="vacation.state === 'request'">{{ __('admin::vacations.state_request') }}</span>
                            <span v-if="vacation.state === 'upcoming'">{{ __('admin::vacations.state_upcoming') }}</span>
                            <span v-if="vacation.state === 'current'">{{ __('admin::vacations.state_current') }}</span>
                            <span v-if="vacation.state === 'old'">{{ __('admin::vacations.state_old') }}</span>
                        </span>
                    </td>
                    <td>{{ vacation.deputy_user?.name || '—' }}</td>
                    <td>{{ vacation.use_default_messages ? __('admin::labels.default_messages') : __('admin::labels.custom_messages') }}</td>
                    <td>{{ vacation.days_to_show_notice_before_start }} {{ __('admin::labels.days_before').toLowerCase() }}</td>
                    <td>{{ vacation.comment || '—' }}</td>
                    <td>
                        <TableButton
                            variant="edit"
                            :href="$route('admin::my-vacations.edit', { vacation: vacation.id })"
                            v-if="! vacation.is_approved"
                        />
                        <TableButton
                            variant="destroy"
                            @delete="deleting = $route('admin::my-vacations.destroy', { vacation: vacation.id })"
                            v-if="! vacation.is_approved"
                        />
                    </td>
                </tr>
            </template>

        </Table>

        <DeleteDialog
            :title="__('admin::general.delete_model', { model: __('admin::vacations.vacation_request') })"
            :url="deleting"
            v-if="deleting"
            @closed="deleting = null"
        />

    </IndexModelLayout>
</template>

<script>
export default {
    props: {
        paginator: Object,
        request: Object,
    },
    data() {
        return {
            deleting: null,
        }
    },
}
</script>
